import {
    Clock,
    Sparkles,
    Users,
    Zap,
    Wind,
    Accessibility,
    Wifi,
    Trees,
    UserCheck,
    Box,
    ShieldCheck,
    ArrowUpCircle,
    Mail,
    Printer,
    Armchair,
    ClipboardList,
    Bike,
    Car,
    Video,
    PhoneCall,
    Coffee,
    Bell,
    Store,
    Dumbbell
} from "lucide-react";
import Container from "~/components/atoms/Container";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { useState } from "react";
import { UniqueVisitorModal } from "../Modals/UniqueVisitorModal/UniqueVisitorModal";

export default function AmenitiesSection({ region }) {
    const amenities = [
        { icon: Clock, label: "24/7 Access" },
        { icon: Sparkles, label: "Office Cleaning" },
        { icon: Users, label: "Collaborative Space" },
        { icon: Zap, label: "Unlimited Electricity" },
        { icon: Wind, label: "Air Conditioning" },
        { icon: Accessibility, label: "Disable Access" },
        { icon: Wifi, label: "Internet" },
        { icon: Trees, label: "Outdoor Public Space" },
        { icon: UserCheck, label: "Receptionist" },
        { icon: Box, label: "Storage Available" },
        { icon: ShieldCheck, label: "After Hour Security" },
        { icon: ArrowUpCircle, label: "High Speed Lift" },
        { icon: Mail, label: "Mail Handling" },
        { icon: Printer, label: "Printing Facilities" },
        { icon: Armchair, label: "Furnished" },
        { icon: ClipboardList, label: "Administration Support" },
        { icon: Bike, label: "Bike Storage Available" },
        { icon: Car, label: "Car Parking in Building" },
        { icon: Video, label: "Meeting Rooms" },
        { icon: PhoneCall, label: "Telephone Answering" },
        { icon: Coffee, label: "Shared Kitchen" },
        { icon: Bell, label: "Ground Floor Concierge" },
        { icon: Store, label: "Retail in Building" },
        { icon: Dumbbell, label: "Gym / Fitness Center" },
    ];
    const [uniqueVisitorModal, setUniqueVisitorModal] = useState(false);

    return (
        <section className="bg-[#F8FAFC] py-16 font-montserrat">
            <Container htmlFor="max-wide">
                <div className="mx-auto max-w-6xl px-4">
                    <h2 className="mb-12 text-center text-[28px] font-bold text-oh-black">
                        Built-In Amenities for Modern Teams
                    </h2>

                    <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4">
                        {amenities.map((item, index) => (
                            <div
                                key={index}
                                className="group flex items-center gap-3 rounded-xl border border-gray-100 bg-white p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-oh-black/10 hover:shadow-md sm:p-4"
                            >
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-oh-black/5 text-oh-black transition-colors duration-200 group-hover:bg-oh-black group-hover:text-white">
                                    <item.icon className="h-5 w-5" size={20} />
                                </div>
                                <span className="text-sm font-medium leading-snug text-oh-black sm:text-base">
                                    {item.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='flex justify-center pt-8 px-4 '>
                    <OhButton onClick={() => setUniqueVisitorModal(true)} className='px-16 w-full md:w-auto'>
                        Get Started
                    </OhButton>
                </div>

            </Container>
            {
                uniqueVisitorModal && (

                    <UniqueVisitorModal visible={uniqueVisitorModal} params={null} handleCancel={() => setUniqueVisitorModal(false)} handleSubmit={() => setUniqueVisitorModal(false)} region={region} />
                )
            }
        </section>
    );
}
